import { Navigate, Route, Routes } from "react-router-dom";

import Login from "../../pages/Login";
import ForgotPassword from "../../pages/ForgotPassword";
import NewPassword from "../../pages/ForgotPassword/components/NewPassword";

const PublicRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="*" element={<Navigate to="/login" />} />

      <Route path="/login" element={<Login />} />
      <Route path="/new-password" element={<NewPassword />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
    </Routes>
  );
};

export default PublicRoutes;
